module.exports = __webpack_public_path__ + "img/普陀女.f50f0245.png";